module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis18-c7909406ac91193dc55ec6605342c822.jpg";